export default "__VITE_ASSET__CliGtwem__"